import { activeTopics } from "./selectors";
import type { Topic } from "../types";

export function reviewTopics(topics: Topic[]): Topic[] {
  return activeTopics(topics).filter((topic) => topic.status === "待审阅");
}

export function decideTopics(topics: Topic[]): Topic[] {
  return activeTopics(topics).filter((topic) => topic.status === "待确认");
}

export function overdueUnpublished(topics: Topic[], today: string): Topic[] {
  return activeTopics(topics).filter(
    (topic) => topic.status !== "已完成" && topic.status !== "不做" && !!topic.plannedPublishDate && topic.plannedPublishDate < today,
  );
}

export function dueToday(topics: Topic[], today: string): Topic[] {
  return activeTopics(topics).filter((topic) => topic.status === "待发布" && topic.plannedPublishDate === today);
}
